import { render, staticRenderFns } from "./ProjectSkillStats.vue?vue&type=template&id=0f74380a&"
import script from "./ProjectSkillStats.vue?vue&type=script&lang=js&"
export * from "./ProjectSkillStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports